import { render, staticRenderFns } from "./BasicInformationForm.vue?vue&type=template&id=50eca451"
import script from "./BasicInformationForm.vue?vue&type=script&lang=js"
export * from "./BasicInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports